export const state = () => ({
    selectOwnership: {},
    Result:'',
    editOwnership:{
        
    },
    birthCountryOwner: false

})  